import React, { useState, useEffect } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
  IconButton,
  Box,
  Paper,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
  Link as MUILink,
} from "@mui/material";
import WorkIcon from "@mui/icons-material/Work";
import CodeIcon from "@mui/icons-material/Code";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import SortIcon from "@mui/icons-material/Sort";
import TuneIcon from "@mui/icons-material/Tune"; // Filter Toggle Icon
import myImage from '../../images/about/about_image_3.webp';
import { Link } from "react-router-dom";
import { Pointer } from "lucide-react";

const SearchFilterSection = ({
  experience,
  setExperience,
  skillset,
  setSkillset,
  location,
  setLocation,
  jobType,
  setJobType,
  jobMode,
  setJobMode,
  department,
  setDepartment,
  sortOrder,
  setSortOrder,
  applyFilters,
  clearFilters,
  experiences,
  skillsets,
  countries,
  jobTypeOptions,
  departmentOptions,
}) => {
  const [showFilters, setShowFilters] = useState(window.innerWidth >= 1024);

  

  useEffect(() => {
    const handleResize = () => {
      setShowFilters(window.innerWidth >= 1024);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  //This code is for department tag filter
  const handleDepartmentClick = (dept) => {
    console.log("Clicked department:", dept);
    setDepartment(dept);
  };

  //This code is for Job Mode filter
  // const handleJobModeClick = (jobmode) => {
  //   console.log("Clicked jobMode:", jobMode);
  //   setJobMode(jobMode);
  // };

  return (
    <>
      

      {/* Filters Section */}
      {showFilters && (
        <Paper elevation={3} sx={{ p:2, borderRadius: "12px", boxShadow:"none", backgroundColor:"#fff", border:"solid 1px #e1e1e1" }}>
          <Grid container spacing={0} sx={{backgroundColor:"#eee", padding:"12px", paddingBottom:"20px"}} >
            <Grid item xs={12} sx={{pt:"0px !important" }}>
              {/* Always Show Title */}
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb:2, pb:1, borderBottom:"solid 0px #1976d2"}}>
                <Typography variant="h6" fontSize={18} fontWeight={600} >
                  Filter Jobs
                </Typography>

                {/* Toggle Button Only for Mobile */}
                {window.innerWidth < 1024 && (
                  <IconButton onClick={() => setShowFilters(!showFilters)}>
                    <TuneIcon color="primary" />
                  </IconButton>
                )}
              </Box>
            </Grid>

          {/* Skillset Filter */}
            {/* <Grid item xs={6} sx={{ mb:1}}>
              <FormControl fullWidth sx={{ minWidth: 120 }} size="small">
                <InputLabel>Skillset</InputLabel>
                <Select
                  value={skillset}
                  onChange={(e) => setSkillset(e.target.value)}
                  startAdornment={
                    <InputAdornment position="start">
                      <CodeIcon color="primary" sx={{fontSize:"16px"}} />
                    </InputAdornment>
                  }
                  label="Skillset"
                >
                  <MenuItem value="">All Skills</MenuItem>
                  {skillsets.map((skill) => (
                    <MenuItem key={skill} value={skill}>
                      {skill}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid> */}
            <Grid container direction="row" spacing={1}>
              <Grid item xs={6} sx={{ mb:1}}>
                {/* Job Type Filter */}
                <FormControl fullWidth sx={{ minWidth: 120, backgroundColor:"#fff" }} size="small">
                  <InputLabel>Job Type</InputLabel>
                  <Select
                    value={jobType}
                    onChange={(e) => setJobType(e.target.value)}
                    startAdornment={
                      <InputAdornment position="start">
                        <BusinessCenterIcon color="primary"  sx={{fontSize:"16px"}} />
                      </InputAdornment>
                    }
                    label="Job Type" sx={{minHeight:"44px"}}
                  >
                    <MenuItem value="">All Job Types</MenuItem>
                    {jobTypeOptions.map((type) => (
                      <MenuItem key={type} value={type}>
                        {type}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6} sx={{ mb:1}}>
                {/* Department Filter */}
                <FormControl fullWidth sx={{ minWidth: 120, backgroundColor:"#fff" }} size="small">
                  <InputLabel>Department</InputLabel>
                  <Select
                    value={department}
                    onChange={(e) => setDepartment(e.target.value)}
                    startAdornment={
                      <InputAdornment position="start">
                        <AccountBalanceIcon color="primary" sx={{fontSize:"14px"}} />
                      </InputAdornment>
                    }
                    label="Department" sx={{minHeight:"44px"}}
                  >
                    <MenuItem value="">All Departments</MenuItem>
                    {departmentOptions.map((dept) => (
                      <MenuItem key={dept} value={dept}>
                        {dept}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            <Grid item xs={12} sx={{ mb:2, mt:2}} style={{height:"140px",paddingBottom:"6px", overflow:"auto"}}>
              {departmentOptions.map((dept) => (
                  <span className="px-2 border me-1 mb-1 departmentTagBtn {`department-chip ${selectedDept === dept ? 'active' : ''}`}" key={dept} onClick={() => handleDepartmentClick(dept)}>{dept}</span>
              ))}
            </Grid>
            
            <Grid container direction="row" spacing={2} sx={{ justifyContent: "left", alignItems: "center", }}>
              <Grid item sx="me-3">
                {/* Apply Filters */}
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  onClick={applyFilters}
                  size="medium"
                  sx={{ py: 1, boxShadow:0, borderRadius: "2px", fontSize:"12px" }} >
                  Apply Filters
                </Button>
              </Grid>

              <Grid item>
                {/* Clear Filters */}
                <Button
                  fullWidth
                  variant="outlined"
                  color="primary"
                  onClick={clearFilters}
                  size="medium"
                  sx={{ py: 1, borderRadius: "2px", fontSize:"12px", backgroundColor:"#fff" }}
                >
                  Clear All
                </Button>
              </Grid>
            </Grid>
          </Grid>
          
          <Card
          variant="outlined"
          sx={{
            maxWidth: "100%",
            boxShadow: "0px 0px 10px #888",
            paddingTop: "32px",
            background: "linear-gradient(45deg, #002791, #b100c6)",
            color: "#fff",
            marginTop:"32px",
          }}
        >
          <CardContent sx={{ paddingTop: "0px" }}>
          <img src={myImage} alt="My example" style={{ width: '300px' }} />;
            <Typography variant="h2" sx={{ fontSize: "18px", fontWeight: "bold", marginBottom: "8px", color: "#fff" }}>Simplify HR with Texora</Typography>
            <Typography variant="body2" sx={{ color: "text.secondary", color: "#fff", fontSize: "14px" }}>
              All-in-one HR software to manage payroll, attendance, leave, and more—effortlessly.<br />

            </Typography>
            <Typography sx={{ lineHeight: "24px", fontSize: "14px", color: "#fff", marginTop: "6px", marginBottom: "8px" }}>
              ✔ Easy to use &nbsp;
              ✔ Fully customizable<br />
              ✔ Trusted by growing teams<br />
            </Typography>
            <Typography component={Link} to="https://texora.ai/" variant="h3" sx={{ fontSize: "14px", fontWeight: "semibold", color: "#000", marginTop: "10px", backgroundColor: "#fff", display: "inline-block", padding: "8px 10px", border: "none", cursor:"pointer" }}>Try Texora free today!</Typography>
          </CardContent>
        </Card>
        </Paper>
      )}
    </>
  );
};

export default SearchFilterSection;
